<template>
  <div>
    <v-container v-if="showTemplateWorkflow && !isRefreshingState" style="height: 100%" fluid>
      <v-row class="flex-column main-layout w-100">
        <v-col cols="12">
          <Toolbar
            back-nav-route="TemplatesPage"
            :tabs-title="$t('templatesPage.toolbar.tabsTitle')"
            :toolbar-tabs="templateToolbarTabs"
            :workpackage="selectedWorkpackage"
            :show-statuses="false"
          />
          <router-view :key="routerKey" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { useScenariosStore } from '@/stores/scenarios';
import { useWorkpackageProductsStore } from '@/stores/workpackage-products';
import { useWorkpackagesStore } from '@/stores/workpackages';
import templateToolbarTabs from '@/utils/tabs/template-toolbar-tabs-enum';
import toolbarTabs from '@/utils/tabs/toolbar-tabs-enum';
import { get, includes, intersectionWith, some } from 'lodash';
import { mapActions, mapState } from 'pinia';

export default {
  async beforeRouteLeave(to, from, next) {
    /* Ensure to reset any data that can overlap between templates/home page  */
    await this.setSelectedWorkpackage(null);
    await this.setWorkpackageProducts([]);
    await this.setScenarioPanelExpanded(false);
    return next();
  },

  data() {
    return {
      templateToolbarTabs,
      isRefreshingState: false,
    };
  },

  computed: {
    ...mapState(useWorkpackagesStore, ['selectedWorkpackage']),
    ...mapState(useScenariosStore, ['selectedScenario']),

    scenarioTabs() {
      return intersectionWith(
        toolbarTabs.ALL,
        this.templateToolbarTabs.ALL,
        (toolbarTab, templateTab) => toolbarTab.id === templateTab.id
      );
    },

    workpackageId() {
      return this.$route.params.templateId || get(this.selectedWorkpackage, '_id');
    },

    scenarioId() {
      return this.$route.params.templateScenarioId || this.selectedScenario._id;
    },

    routerKey() {
      return `${this.workpackageId}-${this.scenarioId}`;
    },

    showTemplateWorkflow() {
      /* In scenario-workflow.vue, the scenarioId value must be set before displaying tab content.
         The template workflow will include some of the same tabs as scenario workflow. As a result,
         we need to ensure that the scenarioId value is set before showing content for those tabs */
      if (some(this.scenarioTabs, t => includes(this.$route.fullPath, t.id)))
        return this.selectedWorkpackage && this.selectedScenario._id;
      return this.selectedWorkpackage;
    },
  },

  async created() {
    await this.handleNavigationChanges();
  },

  methods: {
    ...mapActions(useWorkpackagesStore, [
      'loadState',
      'refreshWorkpackageInformation',
      'setSelectedWorkpackage',
      'setScenarioPanelExpanded',
    ]),
    ...mapActions(useWorkpackageProductsStore, ['setWorkpackageProducts']),

    async handleNavigationChanges() {
      this.isRefreshingState = true;
      await this.refreshWorkpackageInformation({
        workpackageId: this.workpackageId,
        forceStateUpdate: true,
      });
      await this.loadState({ workpackageId: this.workpackageId });
      this.isRefreshingState = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.main-layout {
  height: 100%;
}
</style>
